
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/internships/[id]",
      function () {
        return require("private-next-pages/internships/[id]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/internships/[id]"])
      });
    }
  